import { Container } from './CustomFields.styles';
import { CustomFieldsTab } from './Components/CustomFieldsTab/CustomFieldsTab';

const CustomFields = () => {
  return (
    <Container>
      <CustomFieldsTab />
    </Container>
  );
};

export { CustomFields };
